module.exports = __webpack_public_path__ + "static/media/bg-title@2x.6620ff75.jpg";